import { render, staticRenderFns } from "./recordTest.vue?vue&type=template&id=d8c0b612&scoped=true"
import script from "./recordTest.vue?vue&type=script&lang=js"
export * from "./recordTest.vue?vue&type=script&lang=js"
import style0 from "./recordTest.vue?vue&type=style&index=0&id=d8c0b612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c0b612",
  null
  
)

export default component.exports